export default __webpack_public_path__ + "static/media/fpbh0030.be8cc8d0.png";